<template>
  <div>
    <div v-if="loadingCategories" class="mt-3">
      <div class="text-center">
        <v-progress-circular indeterminate size="100" width="8"></v-progress-circular>
      </div>
      <v-row justify="center" class="mt-8">
        <v-col cols="2" class="text-center">
          <p class="basic--text">
            Searching for categories to map... Please wait...
          </p>
        </v-col>
      </v-row>
    </div>

    <div v-if="categoriesFailed">
      <v-row class="pb-2" justify="center">
        <v-img :src="require(`@/assets/${responseImg}`)" max-width="300">
        </v-img>
      </v-row>
      <v-row class="pb-2 text-center" justify="center">
        <h3 class="basic--text">{{ responseMessage }}</h3>
      </v-row>
    </div>

    <div v-if="showCategoriesTable">
      <v-row justify="center">
        <v-col>
          <h2 class="basic--text text-center">
            <v-icon color="secondary"> mdi-translate</v-icon> Translations
          </h2>
          <p class="basic--text text-center">
            Please translate the following words
          </p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="8">
          <v-form ref="form">
            <v-data-table dense :items="parameters" :headers="headers" :footer-props="{
              'items-per-page-options': [30, 50, 100, 150, 200],
            }">
              <template v-slot:[`item.value`]="{ item }">
                <v-text-field outlined dense v-model="item.value" type="text" :rules="[rules.required]"
                  hide-details="auto" style="width: 100%"></v-text-field>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1"><v-btn outlined color="error" @click="getTranslations">
            <v-icon left>mdi-arrow-left-bold-outline</v-icon>
            Back
          </v-btn></v-col>
        <v-spacer></v-spacer>
        <v-col cols="1"><v-btn outlined color="success" @click="goToUpload">Next <v-icon
              right>mdi-arrow-right-bold-outline</v-icon></v-btn></v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryMapping",
  props: {
    skus: Array,
    platform: Object,
  },
  components: {},
  computed: {},
  data: () => ({
    loadingCategories: true,
    categoriesFailed: false,
    showCategoriesTable: false,

    responseImg: "",
    responseMessage: "",
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    parameters: [],
    headers: [
      { text: "ProductsDB category", value: "productsDBCategory" },
      { text: "Ebay category", value: "ebayCategory" },
      { text: "Ebay store category", value: "ebayStoreCategory" },
    ],
  }),
  async mounted() {
    await this.getMissingPlatformParameters();
  },
  methods: {
    async getMissingPlatformParameters() {
      let data = {
        platform: this.platform.platform,
        skus: this.skus,
      };
      try {
        const response = await this.$store.dispatch(
          "getMissingPlatformParameters",
          data
        );
        console.log(response);

        // Add these lines to handle the response:
        this.loadingCategories = false;

        if (response && response.length > 0) {
          // Map the response to your parameters format
          this.parameters = response.map(item => ({
            productsDBCategory: `${item.gender} - ${item.category}`,
            ebayCategory: '',
            ebayStoreCategory: '',
            gender: item.gender,
            category: item.category,
            value: '' // Add this if needed for v-model
          }));
          this.showCategoriesTable = true;
        } else {
          // No missing parameters found
          this.categoriesFailed = true;
          this.responseImg = 'success.png'; // Or appropriate image
          this.responseMessage = 'All categories are already mapped!';
        }

      } catch (error) {
        console.log(error);
        this.loadingCategories = false;
        this.categoriesFailed = true;
        this.responseImg = 'error.png'; // Use appropriate error image
        this.responseMessage = 'Failed to load categories. Please try again.';
      }
    },
    getTranslations() {
      this.$emit("getTranslations");
    },
    goToUpload() {
      this.$emit("goToUpload");
    },
  },
};
</script>
